import '../styles/learn-more.css'
import React from 'react';

class LearnMoreComponent extends React.Component {

  render() {
    return (
      <div className="LearnMoreComponentContainer no-print Roboto">
        {/* <div className="LearnMoreHeader">
          <h2 className='Oswald uppercase gappyText'>Want to learn more?</h2>
        </div>
        <p>Check out these additional available resources:</p> */}
        <div className="LearnMoreBody shrink-to-fit">
          <div className="LearnMoreEntryRow shrink-to-fit">
            {/* <div className="LearnMoreEntry">
                  <p className="title">Want to know more about your location's wildfire risk?</p>
                  <p>Visit the Wildfire Risk Assessment Portal (WRAP) to get a report on your location:</p>
                  <div className="LearnMoreLink">
                    <a href="/LearnMoreWRAP">Go to the WRAP</a>
                  </div>
                </div> */}
                { /* My recolection from the client is that they actually wanted to go to the map but BA says otherwise so I will leave this hiddenm in here for now */ }
            <div className="LearnMoreCell hidden">
              <div className="LearnMoreEntry shrink-to-fit">
                <h3 className="title">Interested in learning more about post-wildfire recovery?</h3>
                <p>Visit Utah State University post-wildfire resources map.</p>
                <a className='button primary' href={`https://maps.nwcg.gov/sa/#/%3F/%3F/${this.props.lat}/${this.props.lon}/${this.props.zoom}`} target='blank' >Go to USU Post Wildfire Resources Map</a>
              </div>
            </div>
            <div className="LearnMoreCell">
              <div className="LearnMoreEntry shrink-to-fit">
                <h3 className="title">Interested in learning more about post-wildfire recovery?</h3>
                <p>Visit Utah State University post-wildfire resources.</p>
              </div>
              <a className='button primary Oswald' href='https://extension.usu.edu/Post-Wildfire/' target='blank' >Go to USU Post Wildfire Resources</a>
            
            </div>
          </div>
        </div>
      </div>

    )
  }
}


export default LearnMoreComponent;